//muestra una tabla con el total de lecturas de Euros, tokens y tickets de todas las máquinas para cada fecha dentro de la semana 
// (normalemte solo habrá una fila para el día de cierre semanal, que es cuando se introducen las lecturas de las máquinas)
// cada una de las filas de esta tabla tiene un botón de editar que muestra el componente CierreSemanalLecturasArcade en una ventana modal
// con la lista de máquinas y sus valores

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//import { modifyDatosCierreDiario, getArtGastosCentro, getTipogastosCierre } from '../../actions/cierreDiarioActions';
import { openDialog } from '../../actions/index';
import NeuriteGrid from '../../components/neurite_grid';
import grey from '@material-ui/core/colors/grey';
import { Typography } from '@material-ui/core';


const styles = theme => ({
    root: {
        marginTop: theme.spacing(1),
        width: 550
    },
    button: {
        margin: theme.spacing(1),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    typography: {
        color: theme.palette.secondary.main,
        margin: theme.spacing(1)
    }
});

const CierreSemanalMaqArcade = props => {

    const showMaquinas = (row) => {
        props.openDialog('CierreSemanalLecturasArcade', { fecha: row.fecha }, uuidv4(), true, "md");
    };

    const { classes } = props;


    return (
        props.datosCierreSemanal.cajaIDgeneral === undefined ?
            '' :
            <div className={classes.root}>
                {props.datosCierreSemanal.arcade ?
                    <div>
                        <Typography variant="h6" className={classes.typography}>{'Lecturas arcade'}</Typography>
                        <NeuriteGrid
                            id="c_s_m_a"
                            columns={[
                                { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 80 },
                                { key: props.isSemanaCerrada ? 'euros' : 'eurosSinMult', name: 'Euros', editable: false, dragable: false, type: 'float', width: 95 },
                                { key: 'tokens', name: 'Tokens', editable: false, dragable: false, type: 'int', width: 95 },
                                { key: 'tickets', name: 'Tickets', editable: false, dragable: false, type: 'int', width: 95 },
                                { key: 'visas', name: 'VISAS', editable: false, dragable: false, type: 'int', width: 95 },
                            ]}
                            rows={props.datosCierreSemanal.arcade}
                            width={590}
                            height={100}
                            headerRenderer={{ color: 'black', bg: grey[300], border: 'none', align: 'left' }}
                            buttonEdit={true}
                            buttonDelete={false}
                            buttonNew={false}
                            onEditClick={showMaquinas}
                            enableSelection={false}
                        />
                    </div>
                    : ''}
            </div>
    );
};


CierreSemanalMaqArcade.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    datosCierreSemanal: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isSemanaCerrada: state.centroDiaSelected.isSemanaCerrada,
        datosCierreSemanal: state.datosCierreSemanal.datos,
        user: state.oidc.user
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        openDialog
    }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalMaqArcade));